module.exports = __webpack_public_path__ + "static/media/Baeckerei.eadef480.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/Baeckerei.JPG
// module id = 667
// module chunks = 0